const KEY = "clever_mic_consent";

function readAll(): Record<string, boolean> {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Record<string, boolean>) : {};
  } catch {
    return {};
  }
}

export function readMicLocal(learnerId: string): boolean | null {
  const all = readAll();
  return learnerId in all ? Boolean(all[learnerId]) : null;
}

export function writeMicLocal(learnerId: string, granted: boolean): void {
  const all = readAll();
  all[learnerId] = granted;
  localStorage.setItem(KEY, JSON.stringify(all));
}
